export const TYPE_LABELS = { 1178: "Sinopse" };

const EPISODE_TYPE_ID = 1211;

export function groupMaterials(materials) {
  const acc = {};

  materials.forEach((item) => {
    if (!item?.type.id) return;

    const typeId = Number(item.type.id);

    if (!acc[typeId]) {
      acc[typeId] = [];
    }

    acc[typeId].push(item);
  });

  const result = [];

  const sortedEntries = Object.entries(acc).sort(
    ([aId, aItems], [bId, bItems]) => {
      const aIsEnd = Number(aId) === EPISODE_TYPE_ID;
      const bIsEnd = Number(bId) === EPISODE_TYPE_ID;
      if (aIsEnd !== bIsEnd) return aIsEnd ? 1 : -1;
      const aName = aItems[0]?.type?.name || "";
      const bName = bItems[0]?.type?.name || "";
      return aName.localeCompare(bName);
    }
  );

  sortedEntries.forEach(([typeId, items]) => {
    const numericTypeId = Number(typeId);

    if (numericTypeId === EPISODE_TYPE_ID) {
      const byEpisode = items.reduce((epAcc, item) => {
        const ep = Number(item.episodeNumber) || 0;

        if (!epAcc[ep]) {
          epAcc[ep] = [];
        }

        epAcc[ep].push(item);

        return epAcc;
      }, {});

      Object.keys(byEpisode)
        .map(Number)
        .sort((a, b) => a - b)
        .forEach((ep) => {
          result.push({
            [numericTypeId]: byEpisode[ep].sort(
              (a, b) => (b.version || 0) - (a.version || 0)
            ),
            name: `Episódio ${ep}`,
          });
        });

      return;
    }

    result.push({
      [numericTypeId]: [...items].sort(
        (a, b) => (b.version || 0) - (a.version || 0)
      ),
      name: items[0]?.type?.name,
    });
  });

  return result;
}

export function sortBlocks(blocks) {
  return [...blocks].sort((a, b) => a.number - b.number);
}
